import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 *
 */
class DepartmentService {
  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param departmentId
   * @param tenantId
   * @param isAdmin
   * @return {Promise<*>}
   */
  getDepartments = async (keyword, tenantId, page, limit, departmentId, orgId, isAdmin, multipleSelectedTenantIds) => {
    let url = `${Constants.DEPARTMENTS}${isAdmin ? '/department_tenants' : ''}?`;
    if (keyword) url += `department_name=${keyword}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (departmentId) url += `department_id=${departmentId}`;
    if (multipleSelectedTenantIds) url += `tenant_ids=${multipleSelectedTenantIds}`
    const departments = await Helpers.get({ url });
    return departments;
  }

     /**
      * @param departmentId
      * @param tenantId
      * @return {Promise<*>}
      */
     getDepartmentById = async (departmentId, tenantId) => {
       const department = await Helpers.get({
         url: `${Constants.DEPARTMENTS}?department_id=${departmentId}&tenant_id=${tenantId}`,
       });
       return department;
     }

     /**
      *
      * @param payload
      * @return {Promise<void>}
      */
     createDepartment = async (payload) => {
       const createdDepartment = await Helpers.post({
         url: Constants.DEPARTMENTS,
         data: payload,
       });
       return createdDepartment;
     }

     /**
      * @param payload
      * @return {Promise<*>}
      */
     updateDepartment = async (payload) => {
       const department = await Helpers.put({
         url: Constants.DEPARTMENTS,
         data: payload,
       });
       return department;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
      updateDepartmentStatus = async (payload) => {
        const department = await Helpers.put({
          url: Constants.DEPARTMENTS_STATUS,
          data: payload,
        });
        return department;
      }

      /**
       *
       * @param {*} payload
       * @return
       */
      deleteDepartment = async (payload) => {
        const department = await Helpers.delete({
          url: Constants.DEPARTMENTS,
          data: payload,
        });
        return department;
      }
}

export default new DepartmentService();
